export enum BuildingUseFunctionNamesEnum {
    WoonfunctieEengezins = 'Woonfunctie eengezins',
    Bijeenkomstfunctie = 'Bijeenkomstfunctie',
    Celfunctie = 'Celfunctie',
    Woonzorggebouw = 'Woonzorggebouw',
    Industriefunctie = 'Industriefunctie',
    Kantoorfunctie = 'Kantoorfunctie',
    Logiesfunctie = 'Logiesfunctie',
    Onderwijsfunctie = 'Onderwijsfunctie',
    Sportfunctie = 'Sportfunctie',
    Winkelfunctie = 'Winkelfunctie',
    OverigeGebruiksfunctie = 'Overige gebruiksfunctie',
    Zwembaden = 'Zwembaden',
    WoonfunctieMeergezins = 'Woonfunctie meergezins',
    Combinatiegebouw = 'Combinatiegebouw',
    EvenredigVerdelen = 'Evenredig verdelen'
}

export const BuildingUseFunctionNamesById: Record<number, BuildingUseFunctionNamesEnum> = {
    1: BuildingUseFunctionNamesEnum.WoonfunctieEengezins,
    2: BuildingUseFunctionNamesEnum.Bijeenkomstfunctie,
    3: BuildingUseFunctionNamesEnum.Celfunctie,
    4: BuildingUseFunctionNamesEnum.Woonzorggebouw,
    5: BuildingUseFunctionNamesEnum.Industriefunctie,
    6: BuildingUseFunctionNamesEnum.Kantoorfunctie,
    7: BuildingUseFunctionNamesEnum.Logiesfunctie,
    8: BuildingUseFunctionNamesEnum.Onderwijsfunctie,
    9: BuildingUseFunctionNamesEnum.Sportfunctie,
    10: BuildingUseFunctionNamesEnum.Winkelfunctie,
    11: BuildingUseFunctionNamesEnum.OverigeGebruiksfunctie,
    12: BuildingUseFunctionNamesEnum.Zwembaden,
    13: BuildingUseFunctionNamesEnum.WoonfunctieMeergezins,
    14: BuildingUseFunctionNamesEnum.Combinatiegebouw,
    15: BuildingUseFunctionNamesEnum.EvenredigVerdelen
};


export function getBuildingUseFunctionIdByName(name: BuildingUseFunctionNamesEnum): number {
    const match = Object.entries(BuildingUseFunctionNamesById)
        .find(([, value]) => value === name);

    if (!match) {
        throw new Error(`Building use function not found: ${name}`);
    }

    return Number(match[0]);
}